// Product card color swatches — click to preview variant image
(function () {
  if (window.__futxoSwatchInit) return;
  window.__futxoSwatchInit = true;

  document.addEventListener(
    'click',
    function (event) {
      var swatch = event.target.closest('.card__color-swatch');
      if (!swatch) return;

      // Stop the card's full-card link (or anything else) from hijacking this click
      event.preventDefault();
      event.stopPropagation();

      var wrapper = swatch.closest('.card-wrapper');
      if (!wrapper) return;

      // Mark this swatch as selected, clear the others in this card
      wrapper.querySelectorAll('.card__color-swatch').forEach(function (el) {
        el.classList.remove('is-active');
      });
      swatch.classList.add('is-active');

      // Swap the product image to this variant's image, if it has one
          var imageUrl = swatch.getAttribute('data-variant-image');
      if (imageUrl) {
        var imgs = wrapper.querySelectorAll('.card__media img.motion-reduce');
        imgs.forEach(function (img) {
          img.removeAttribute('srcset');
          img.src = imageUrl;
        });
      }

      // Update the product link so it opens on the selected variant
      var variantId = swatch.getAttribute('data-variant-id');
      var link = wrapper.querySelector('.card__heading a.full-unstyled-link');
      if (variantId && link) {
        try {
          var url = new URL(link.href, window.location.origin);
          url.searchParams.set('variant', variantId);
          link.href = url.toString();
        } catch (e) {
          /* ignore malformed URLs */
        }
      }
    },
    true // capture phase: intercept the click before it reaches any overlay link
  );

  // Keyboard accessibility: Enter/Space activates a focused swatch
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    var swatch = event.target.closest('.card__color-swatch');
    if (!swatch) return;
    event.preventDefault();
    swatch.click();
  });
})();